export class DiagramFactoryError extends Error {

    /**
     * Creates a new {@link DiagramFactoryError}.
     * @param message
     *  The error message.
     */
    constructor(message: string) {
        super(message);
    } 

}